import { useEffect } from 'react';
import { useAppDispatch } from 'app/store';
import { setHeaderTitle, setHeaderAction, setActionBtnTitle } from 'features/ui/model/uiSlice';
import { ProductDetailWidget } from 'widgets/product/ui/ProductDetailWidget';

export const ProductDetailPage = () => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(setHeaderTitle('Данные о товаре'));
    dispatch(setHeaderAction('edit'));
    dispatch(setActionBtnTitle('Изменить'));

    return () => {
      dispatch(setHeaderAction(null));
    };
  }, []);

  return <ProductDetailWidget />;
};
